var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { validateOrganizationSubtreeMembershipLimitFunctionName, } from '../../../../../../../backend/features/accounts/shared';
import { addAccountsFromGroupToOrganizationBulkActionType, } from '../../../../../../../backend/features/groups/shared';
import { getOrganizationMap } from '../../../../../../../ui/features/organizations/utils/getOrganizationMap';
import { getFilterForBulkAction } from '../../../../../../../utils';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { FunctionClient } from '@juvare/platform-sdk-js/FunctionClient';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { showOrganizationTreeDialog } from '../../../OrganizationsTreeDialog/OrganizationsTreeDialog';
import { mapAccountRejectedOrganizationsRowsToRequest } from '../mapAccountRejectedOrganizationsRowsToRequest';
import { showAccountsCannotBeAddedToOrganizationsDialog } from './showAccountsCannotBeAddedToOrganizationsDialog';
function toBaseOrgId(id) {
    return id.split('_')[0];
}
const FinalConfirmationDialogContent = ({ t, accountIds, organizationIds, organizationsMap, totalFilteredAccounts, onClose, appliedStorageFilters, onConfirm, }) => {
    const handleConfirm = () => {
        launchBulkAction({
            type: addAccountsFromGroupToOrganizationBulkActionType,
            title: t('panels.accounts.addingAccountsToOrganizations'),
            params: {
                organizationIds: organizationIds,
                filter: getFilterForBulkAction(accountIds, appliedStorageFilters),
            },
        });
        onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
        onClose();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('panels.accounts.addToOrganizationsTitle')),
        React.createElement(DialogContent, null,
            React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle }, t('panels.accounts.addAccountsToOrganizationConfirmation', {
                count: (accountIds === null || accountIds === void 0 ? void 0 : accountIds.length) || totalFilteredAccounts,
            })),
            organizationIds.map((orgId) => {
                var _a;
                return (React.createElement(Box, { sx: {
                        height: 58,
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: themeColors.background,
                        py: 1,
                        px: 2,
                        my: 1,
                    }, key: orgId },
                    React.createElement(Typography, { variant: 'subtitle2' }, (_a = organizationsMap[orgId].columns.name) !== null && _a !== void 0 ? _a : t('common.unknown'))));
            })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => onClose(), "data-test": 'cancel-button' }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', onClick: handleConfirm, "data-test": 'add-button' }, t('common.add')))));
};
function showFinalConfirmationDialog(params, effectiveOrganizationIds) {
    return __awaiter(this, void 0, void 0, function* () {
        const organizationsMap = yield getOrganizationMap(effectiveOrganizationIds);
        const organizationIds = effectiveOrganizationIds.map(toBaseOrgId);
        showCustomDialog({
            maxWidth: 'sm',
            content: (close) => (React.createElement(FinalConfirmationDialogContent, Object.assign({}, params, { onClose: close, organizationsMap: organizationsMap, organizationIds: organizationIds }))),
        });
    });
}
export const handleAddToOrganization = ({ t, accountIds, appliedStorageFilters, onConfirm, totalFilteredAccounts = 0, }) => {
    const validateOrgSubtreeMembershipLimit = (params) => new FunctionClient().executeFunction({ functionName: validateOrganizationSubtreeMembershipLimitFunctionName, params: params });
    showOrganizationTreeDialog({
        multiSelect: true,
        staticFilters: {
            orgPermissions: ['manage-members'],
            visible: false,
        },
        onChange: (addedOrganizationIds) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield validateOrgSubtreeMembershipLimit({
                accountIds,
                organizationIds: addedOrganizationIds,
                accountStorageFilters: appliedStorageFilters,
            });
            const accountRejectedOrganizationsRows = response.result;
            const hasRejectedOrganizations = Array.isArray(accountRejectedOrganizationsRows) && accountRejectedOrganizationsRows.length > 0;
            if (!hasRejectedOrganizations) {
                yield showFinalConfirmationDialog({ t, accountIds, appliedStorageFilters, totalFilteredAccounts, onConfirm }, addedOrganizationIds);
                return;
            }
            showAccountsCannotBeAddedToOrganizationsDialog({
                accountRejectedOrganizationsRows: accountRejectedOrganizationsRows,
                onConfirm: () => {
                    const organizationIds = addedOrganizationIds.map(toBaseOrgId);
                    launchBulkAction({
                        type: addAccountsFromGroupToOrganizationBulkActionType,
                        title: t('panels.accounts.addingAccountsToOrganizations'),
                        params: {
                            organizationIds: organizationIds,
                            accountRejectedOrganizationsMap: mapAccountRejectedOrganizationsRowsToRequest(accountRejectedOrganizationsRows),
                            filter: getFilterForBulkAction(accountIds, appliedStorageFilters),
                        },
                    });
                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
                },
            });
        }),
    });
};
